import clsx from 'clsx';
import { SVG_loading } from './icons';

export default function ELoader({ size, color, text, className }) {
    return (
        <div className={clsx('e-loader', size && `e-loader--${size}`, color && `e-loader--${color}`, text && 'e-loader--text', className)}>
            <SVG_loading />
            {text && <span className="e-loader__text">{text}</span>}
        </div>
    );
}
